export enum SyncIdValue {
    PRODUCTS = 'products',
    PRODUCT_PACKING = 'product_packing',
    PRODUCT_PRICES = 'product_prices',
    PRODUCT_COLLECTIONS = 'product_collections',
}

export enum SyncCommand {
    GENERAL_SYNC = 'general',
    PRODUCTS_SYNC = 'products_sync',
}

export class SyncId {

    private static readonly VALID_VALUES: string[] = Object.values(SyncIdValue);

    private readonly _value: SyncIdValue;

    public constructor(value: string) {
        if (!SyncId.isValid(value)) {
            throw new Error(`Invalid SyncId value: ${value}`);
        }
        this._value = value as SyncIdValue;
    }

    public static isValid(value: string): boolean {
        return SyncId.VALID_VALUES.includes(value);
    }

    public static generalSync(): string {
        return SyncCommand.GENERAL_SYNC;
    }

    public static productsSync(): string {
        return SyncCommand.PRODUCTS_SYNC;
    }

    public get value(): SyncIdValue {
        return this._value;
    }

}
